'use strict';

module.exports = function (ngModule) {
    ngModule.controller('searchController', require('./search'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/search/index.js
 **/